export class SentAssessmentDetail {
    constructor() {
        this.count = 0;
        this.jobMatchIds = [];
        this.candidateAssessmentIds = [];
    }
}
//# sourceMappingURL=sentAssessmentDetail.js.map